var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pdl" },
    [
      _c(
        "el-table",
        {
          attrs: {
            border: "",
            "header-cell-class-name": "tableHeader",
            data: _vm.list,
          },
        },
        [
          _c("el-table-column", {
            attrs: { label: "商品编码", prop: "productCode" },
          }),
          _c("el-table-column", {
            attrs: { label: "商品名称", prop: "productName" },
          }),
          _c("el-table-column", {
            attrs: { label: "产品系列编码", prop: "productLevelCode" },
          }),
          _c("el-table-column", {
            attrs: { label: "产品系列名称", prop: "productLevelName" },
          }),
          _c("el-table-column", {
            attrs: { label: "数量（盒/瓶）", prop: "num" },
          }),
          _c("el-table-column", {
            attrs: { label: "产品单价（元）", prop: "productPrice" },
          }),
          _c("el-table-column", {
            attrs: { label: "产品总价（元）", prop: "productTotalPrice" },
          }),
          _c("el-table-column", {
            attrs: { label: "需货申请行号", prop: "crmsoLine" },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }